import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class DetroitLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Detroit, MI" />
        <LocationMicroNav />

        { /* Need to fix link in this when we switch over to JSON DB */ }
        <LocationContent 
          category="Promoting Ridership" 
          title="Motorless City"
          story='At the kickoff meeting of community partners and Mogo Bikeshare, the National Association of City Transportation Officials (NACTO) brought experts from Philadelphia and Brooklyn to Detroit to show how community-based organizations help shape and steer their bike share program equity goals. We attended to learn how we could replicate this roadshow format for other cities through the Better Bike Share Partnership. A highlight was a bike tour with Wheelhouse Detroit owner Kelli Kavanaugh showcasing gems like the Dequindre Cut, the Riverwalk, and the growing art and urban agriculture installations of Detroit.'
        />  
        <Img
          title="DetroitMi"
          alt="Mogo Bikeshare"
          sizes= { this.props.data.detroitImage.sizes }
        />   

        <LocationRelated 
          prevLocationName="Huntsville, AL"
          prevLocationPath="huntsville"
          prevLocationImgPath= { this.props.data.detroitPrevImage }
          nextLocationName="Charlotte, NC"
          nextLocationPath="charlotte"
          nextLocationImgPath= { this.props.data.detroitNextImage }
        /> 
      </div>
    )
  }
}

export default DetroitLocation

// GraphQL query
export const DetroitImageQuery = graphql`
  query DetroitImageQuery {
    detroitImage: imageSharp(id: { regex: "/PFB_DetroitMI/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    detroitPrevImage: imageSharp(id: { regex: "/PFB_HUNTSVILLE/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    detroitNextImage: imageSharp(id: { regex: "/PFB_CHARLOTTE/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/detroit.js